import { csx } from '@vtex/admin-ui'

export function IconInactive() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="8"
        cy="8"
        r="3.25"
        className={csx({ stroke: '$gray50' })}
        strokeWidth="1.5"
      />
    </svg>
  )
}

export function IconPublished() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="7" className={csx({ fill: '$green20' })} />
      <circle cx="8" cy="8" r="3" className={csx({ fill: '$green40' })} />
    </svg>
  )
}

export function IconPending() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="5" className={csx({ fill: '$orange40' })} />
      <line
        x1="10"
        y1="8"
        x2="6"
        y2="8"
        className={csx({ stroke: '$white' })}
      />
    </svg>
  )
}
